export enum IndustrySector {
  Ecommerce = 'ECommerce',
  FinancialServices = 'FinancialServices',
  Insurance = 'Insurance',
  HospitalityAndAccommodation = 'HospitalityAndAccommodation',
  TransportationAndLogistics = 'TransportationAndLogistics',
  RealEstate = 'RealEstate',
  PublicAdministration = 'PublicAdministration',
  EducationAndResearch = 'EducationAndResearch',
  HealthAndSocialServices = 'HealthAndSocialServices',
  SportsEntertainmentArts = 'SportsEntertainmentArts',
  Construction = 'Construction',
  InformationTechnology = 'InformationTechnology',
  MediaAndCommunication = 'MediaAndCommunication',
  Industry = 'Industry',
}
